import { createSelector } from 'reselect';

var getLoaderState = function getLoaderState(state) {
  return state.loader;
};

export var getLoaderSelector = createSelector(getLoaderState, function (loader) {
  return loader;
});